import { SiExpensify, SiAccusoft, SiPolymerproject } from "react-icons/si";
import {
  CiBank,
  CiGift,
  CiBookmarkMinus,
  CiMoneyBill,
  CiViewList,
  CiLock,
  CiReceipt,
} from "react-icons/ci";
import {
  FaUsers,
  FaNetworkWired,
  FaBusinessTime,
  FaUser,
  FaUserCircle,
  FaUserGraduate,
  FaShoppingBag,
  FaUnity,
  FaReceipt,
} from "react-icons/fa";
import { FaUsersGear, FaUserTie, FaCoins } from "react-icons/fa6";
import {
  MdOutlineBrandingWatermark,
  MdOutlineInventory,
  MdOutlineInventory2,
  MdOutlinePayments,
  MdOutlineWarehouse,
  MdOutlineMoney,
} from "react-icons/md";
import { BiSolidCategory, BiHome } from "react-icons/bi";
import { PiHandCoinsDuotone } from "react-icons/pi";
import {
  LuClipboardCheck,
  LuClipboardCopy,
  LuClipboardSignature,
} from "react-icons/lu";
import { HiOutlineTag } from "react-icons/hi";
import { IoReceipt } from "react-icons/io5";
import { BsReceipt } from "react-icons/bs";
import { TbReceipt } from "react-icons/tb";
const menuData = [
  {
    items: [
      {
        to: "/",
        icon: <BiHome />,
        label: "dashboard",
        allowedRoles: ["manager", "user"],
      },
      {
        to: "/admin-dashboard",
        icon: <BiHome />,
        label: "dashboard",
        allowedRoles: ["administrator"],
      },
    ],
  },

  {
    header: "application",
    items: [
      {
        to: "/branch",
        icon: <FaNetworkWired />,
        label: "branch",
        allowedRoles: ["administrator"],
      },
      {
        to: "/branch-view",
        icon: <FaNetworkWired />,
        label: "branch",
        allowedRoles: ["manager"],
      },
      {
        to: "/employee",
        icon: <FaUserGraduate />,
        label: "employee",
        allowedRoles: ["administrator", "manager"],
      },
      {
        to: "/task-list",
        icon: <FaBusinessTime />,
        label: "project_job",
        allowedRoles: ["administrator"],
      },
      {
        to: "/branch-stock-assignment",
        icon: <CiBank />,
        label: "stock",
        allowedRoles: ["administrator"],
      },
      {
        to: "/branch-target-config",
        icon: <FaBusinessTime />,
        label: "target",
        allowedRoles: ["administrator"],
      },

      {
        to: "/employee-task-assignment",
        icon: <SiPolymerproject />,
        label: "employee_task",
        allowedRoles: ["administrator"],
      },
      {
        to: "/branch-ekyc-devices",
        icon: <FaShoppingBag />,
        label: "ekyc_devices",
        allowedRoles: ["manager"],
      },
      {
        to: "/branch-employee-assignment",
        icon: <SiPolymerproject />,
        label: "employee_task",
        allowedRoles: ["manager"],
      },
      {
        to: "/branch-stock",
        icon: <FaReceipt />,
        label: "stock",
        allowedRoles: ["manager"],
      },
      {
        to: "/task-target",
        icon: <FaBusinessTime />,
        label: "task-target",
        allowedRoles: ["manager", "user"],
      },
      {
        to: "/my-tasks",
        icon: <FaBusinessTime />,
        label: "my-tasks",
        allowedRoles: ["administrator", "manager", "user"],
      },
      {
        to: "/task-approval-request",
        icon: <FaBusinessTime />,
        label: "task-report",
        allowedRoles: ["manager"],
      },
      {
        to: "/employee-attendance",
        icon: <FaBusinessTime />,
        label: "attendance",
        allowedRoles: ["manager"],
      },
      {
        to: "/attendance-report",
        icon: <FaBusinessTime />,
        label: "attendance-report",
        allowedRoles: ["manager"],
      },
      {
        to: "/admin-task-report",
        icon: <FaBusinessTime />,
        label: "task-report",
        allowedRoles: ["administrator"],
      },
      {
        to: "/admin-attendance-report",
        icon: <FaBusinessTime />,
        label: "attendance-report",
        allowedRoles: ["administrator"],
      },

      // {
      //   to: "/humanresource",
      //   icon: <FaUsers />,
      //   label: "HR",
      //   subMenu: [
      //     {
      //       to: "/employee",
      //       icon: <FaUserGraduate />,
      //       label: "employee",
      //     },
      //     {
      //       to: "/labor",
      //       icon: <FaUser />,
      //       label: "labor_list",
      //     },
      //     {
      //       to: "/labor-attendance-sheet",
      //       icon: <FaBusinessTime />,
      //       label: "attendance",
      //     },
      //     {
      //       to: "/attendance/payment-sheet/prepare",
      //       icon: <CiMoneyBill />,
      //       label: "Labor Payment",
      //     },
      //   ],
      // },
      /*
      {
        to: "/payroll",
        icon: <FaCoins />,
        label: "Payroll",
        subMenu: [
          {
            to: "/payroll/employee-payroll",
            icon: <PiHandCoinsDuotone />,
            label: "emp_payroll",
          },

          {
            to: "/payroll/benefit",
            icon: <CiGift />,
            label: "benefit",
          },

          {
            to: "/payroll/deduction",
            icon: <CiBookmarkMinus />,
            label: "deduction",
          },
          {
            to: "/payroll/salary-scale",
            icon: (
              <i className="">
                <MdOutlineMoney />
              </i>
            ),
            label: "salary_scale",
          },
        ],
      },
      {
        to: "/finance",
        icon: <CiBank />,
        label: "finance",
        subMenu: [
          {
            to: "/finance/expense",
            icon: <SiExpensify />,
            label: "expense",
          },
          {
            to: "/finance/expense-category",
            icon: <SiAccusoft />,
            label: "expense_category",
          },

          {
            to: "/finance/payment-method",
            icon: <MdOutlinePayments />,
            label: "payment_method",
          },
        ],
      },
      {
        to: "/ims",
        icon: <FaShoppingBag />,
        label: "IMS",
        subMenu: [
          {
            to: "/ims/warehouses",
            icon: <MdOutlineWarehouse />,
            label: "Warehouses",
          },
          {
            to: "/ims/categories",
            icon: <BiSolidCategory />,
            label: "Item Categories",
          },
          {
            to: "/ims/item-units",
            icon: <FaUnity />,
            label: "Item Units",
          },
          {
            to: "/ims/brands",
            icon: <MdOutlineBrandingWatermark />,
            label: "Item Brands",
          },
          {
            to: "/ims/items",
            icon: <HiOutlineTag />,
            label: "Items",
          },
          {
            to: "/ims/inventories",
            icon: <MdOutlineInventory2 />,
            label: "Inventory",
          },
          {
            to: "/ims/grv",
            icon: <LuClipboardCheck />,
            label: "GRV",
          },
          {
            to: "/ims/purchased-items",
            icon: <MdOutlineInventory />,
            label: "Purchased Items",
          },
          {
            to: "/ims/purchase-requests",
            icon: <LuClipboardSignature />,
            label: "Purchase Requests",
          },
          {
            to: "/ims/item-requests",
            icon: <LuClipboardCopy />,
            label: "Item Requests",
          },
          {
            to: "/ims/items-received",
            icon: <FaReceipt />,
            label: "Items Received",
          },
        ],
      },
      */
      {
        to: "/",
        icon: <FaUsersGear />,
        label: "administrator",
        allowedRoles: ["administrator"],
        subMenu: [
          {
            to: "/user-list",
            icon: <FaUserTie />,
            label: "user_list",
            allowedRoles: ["administrator"],
          },
          {
            to: "/permission-list",
            icon: <CiViewList />,
            label: "permission",
          },
          {
            to: "/recoverpw",
            icon: <CiLock />,
            label: "reset_password",
            allowedRoles: ["administrator"],
          },
        ],
      },
    ],
  },
  {
    header: "user",
    items: [
      {
        to: "/user-profile",
        icon: <FaUserCircle />,
        label: "myProfile",
        allowedRoles: ["administrator", "manager", "user"],
      },
    ],
  },
];

export default menuData;
